import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import liracrypt from '../components/Liracrypt/liracrypt';
import { Col, Form, message, Row } from 'antd';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import StablePrime from '../components/Tables/StablePrime';
import StAddNew from './DSeries/StAddNew';
import ZenTabDynamic from './ZenTabDynamic';
import ButtonPicker from '../components/ReportFormGenerator/Button/Button';
import ZenForm from './ZenForm';
import DynamicZenChart from './DynamicZenChart';
import SortableList from '../components/SortableList';
import ScanterPage from './ScanterPage';
import TaioPage from './TaioPage';

const PhantomSpecial = ({
    setPageHeader,
    urlData,
    respTyp,
    api
}) => {
    const { search } = useLocation();
    const [queryConfig, setQueryConfig] = useState();
    const [queryFormData, setQueryFormData] = useState();
    const [queryForm] = Form.useForm();
    const searchParams = queryString.parse(search);
    const [loading, setLoading] = useState(false);


    const DataTable = () => {
        if (queryFormData) {
            return (
                <div style={{ padding: 10 }}>
                    <PhantomSpecial api={queryConfig?.api} respTyp={queryConfig?.output?.resp} urlData={{ ...urlData, ...queryConfig?.params, ...queryFormData, }} />
                </div>
            )
        }
    }

    // useEffect(() => {
    //     setLoading(true);
    //     setTimeout(() => {
    //         setLoading(false);
    //     }, 500);
    // }, [search, JSON.stringify(urlData)])

    const responseType = {
        'stable': (
            <StablePrime setPageHeader={setPageHeader} zenTable={true} url={api || "/lineperformance"} data={{ ...searchParams, ...urlData }} identity="perfparam" />
        ),
        'staddnew': (
            <div className='phantom-form'>
                <StAddNew
                    colSpan={12}
                    stopResetForm={true}
                    urlEndpoint={api || "/miscellaneous/pageconfig"}
                    urlData={{ ...searchParams, ...urlData }}
                    extraData={{}}
                />
            </div>
        ),
        'scanter': (
            <div>
                <ScanterPage
                    urlEndpoint={"/textapi"}
                    urlData={{ ...searchParams, ...urlData }}
                    setPageHeader={setPageHeader}
                    onFormSubmit={({ values, config }) => { setQueryFormData(values); setQueryConfig(config) }}
                />
                {DataTable}
            </div>
        ),
        'query': (
            <div className='phantom-form'>
                <StAddNew
                    colSpan={12}
                    initForm={queryForm}
                    setPageHeader={setPageHeader}
                    formName="phantomSpecialQueryForm"
                    setSmodalConfig={(config) => { setQueryConfig(config) }}
                    stopResetForm={true}
                    urlEndpoint={api || "/miscellaneous/pageconfig"}
                    urlData={{ ...searchParams, ...urlData }}
                    extraData={{}}
                    onFormSubmit={(values) => {
                        setQueryFormData(null);
                        setTimeout(() => {
                            setQueryFormData(values)
                        }, 100)
                    }}
                />
                {
                    queryConfig?.hide_reset && queryConfig?.hide_submit ?
                        <></> :
                        <Row gutter={24} justify="center">
                            <Col span={24}>
                                <ButtonPicker
                                    submitBtnId={"phantomSpecialQuerySbmt"}
                                    form={queryForm}
                                    formName={"phantomSpecialQueryForm"}
                                    hide_submit={queryConfig?.hide_submit}
                                    // marginLeft={btnMargin ? btnMargin : "320px"}
                                    loading={false}
                                    cancelButtonText={queryConfig?.hide_reset ? false : "Reset"}
                                    submitButtonText={"Submit"}
                                //  resetButton={true}
                                />
                            </Col>
                        </Row>
                }
                {DataTable}
            </div>
        ),
        'layout': (
            <ZenForm urlEndpoint={api || "/miscellaneous/pageconfig"} urlData={{ ...searchParams, ...urlData }} setPageHeader={setPageHeader} />
        ),
        'taio': (
            <TaioPage urlEndpoint={api || "/miscellaneous/pageconfig"} urlData={{ ...searchParams, ...urlData }} setPageHeader={setPageHeader} />
        ),
        'tabs': (
            <ZenTabDynamic api={api} urlData={{ ...urlData }} />
        ),
        'dashboard': (
            <DynamicZenChart api={api} urlData={{ ...urlData }} />
        ),
        'draggableList': (
            <SortableList api={api || '/pms/sprinttasks'} urlData={{ ...searchParams, ...urlData }} setPageHeader={setPageHeader} />
        )
    }

    return (
        <div>
            {
                loading ?
                    <p>Loading...</p> :
                    <>
                        {responseType[respTyp || searchParams.resp]}
                    </>
            }
        </div>
    )
};

export default PhantomSpecial;